import { type FileType, getFileExtensionByMimeType, type ImageFileType, imageFileTypes } from 'BreetHelpers';
import { useFileInfo } from 'BreetHooks';
import { kybAuthSelectors, useAppSelector } from 'BreetRedux';

import { FilePreviewCTA } from './components/CTA';
import { Image } from './components/Image';
import { FileNoPreview } from './components/NoPreview';
import { Pdf } from './components/Pdf';

const DialogFilePreview = () => {
	const { selectPreviewFile } = kybAuthSelectors;

	const previewFile = useAppSelector(selectPreviewFile);

	const fileInfoProps = useFileInfo(previewFile.previewUrl);

	const mimeType: FileType | undefined = !previewFile.type
		? fileInfoProps.mimeType
		: getFileExtensionByMimeType(previewFile.type);

	const isImage = imageFileTypes.includes(mimeType as ImageFileType);

	const fileNotRecognized = !isImage && mimeType !== 'pdf';

	return (
		<div className='file-preview-wrapper bg-primary-600 border-primary-600'>
			{fileNotRecognized ? (
				<FileNoPreview mimeType={mimeType} />
			) : (
				<>
					{mimeType === 'pdf' && <Pdf pdfFile={previewFile.previewUrl} />}

					{isImage && <Image src={previewFile.previewUrl} />}
				</>
			)}

			<FilePreviewCTA
				inputFileSelectorId={previewFile.fileSelectorId}
				modalId='previewKYBFile'
			/>
		</div>
	);
};

export default DialogFilePreview;
